import React from 'react';

import { FieldErrorView } from './FieldError.view';

export const FieldError = ({ name }: { name: string }) => (
  <FieldErrorView name={name} />
);
